import EventItem from './EventItem';
import PropTypes from 'prop-types';
import React from 'react';
import SuperLink from './SuperLink';


const PRODUCTS_PER_PAGE = 3;


export default class MLatestRelatedEvents extends React.Component{
  state = {
    currentPage: 1,
  };


  renderEvents(){
    if(!this.props.latestEvents.events) return null;

    return this.props.latestEvents.events.slice(0, PRODUCTS_PER_PAGE).map((event, index) => {
      return (
        <div key={event.id} className="col-12 events__listing-item">
          <EventItem event={event} disableDate disableLocation className={index === PRODUCTS_PER_PAGE - 1 ? 'remove--border' : ''}/>
        </div>
      );
    });
  }
  renderLink(){
    const eventsLink = this.props.program && this.props.program.id ? `/events?program=${this.props.program.id}` : '/events';

    return (
      <div className="navigationlink navigationlink--blue-outline">
        <SuperLink to={eventsLink} className="navigationlink__link">
          <div className="navigationlink__title">{this.props.latestEvents.linkText || 'View All Events'}</div>
        </SuperLink>
      </div>
    );
  }
  renderTitle(){
    if(this.props.latestEvents.title) return (<div className="m-latest-events__title">{this.props.latestEvents.title}</div>);
    else return (<div className="m-latest-events__title">LATEST EVENTS</div>);
  }
  render(){
    if(!this.props.latestEvents ||
       !this.props.latestEvents.events ||
       this.props.latestEvents.events.length < 1) return null;

    return (
      <div className={`m-latest-events ${this.props.className || ''}`}>
        <div className="container container--coupling">
          {this.renderTitle()}
          <div className="events__listing">
            <div className="row">
              {this.renderEvents()}
            </div>
          </div>
          {this.renderLink()}
        </div>
      </div>
    );
  }
}


MLatestRelatedEvents.propTypes = {
  className: PropTypes.string,
  latestEvents: PropTypes.object,
  program: PropTypes.object,
};
